export * from './basic-echart.component';
export * from './basic-echart.module';
